import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import DashboardDetails from './pages/DashboardDetails';
import Socioeconomico from './pages/Socioeconomico';
import Empreendimentos from './pages/Empreendimentos';
import Mapa from './pages/Mapa';
import Planos from './pages/Planos';
import Configuracoes from './pages/Configuracoes';
import DetalhesEmpreendimento from './pages/DetalhesEmpreendimento';
import Login from './pages/Login';
import EsqueciSenha from './pages/EsqueciSenha';
import MudarSenha from './pages/MudarSenha';
import Cadastro from './pages/Cadastro';
import ProtectedRoute from "./components/ProtectedRoute";
import SemAcesso from "./pages/SemAcesso";
import { authService } from "./API/auth";
import { useEffect, useState } from "react";
import Loading  from './components/Loading';

import { JSX } from 'react';

function App(): JSX.Element {
  const [loading, setLoading] = useState(true);
  const [acessos, setAcessos] = useState<string[]>([]);

  useEffect(() => {
    setAcessos([]);

    const token = authService.getToken();

    if (!token?.access) {
      localStorage.clear();
      setLoading(false);
      return;
    }

    authService.getProfile()
      .then((user) => {

        if (user.tipo === "FRQ") {
          authService.logout();
          localStorage.clear();
          setAcessos([]);
          window.location.replace("/login");
          return;
        }

        if (
          user.tipo === "TACT" ||
          user.is_staff ||
          user.is_superuser
        ) {
          setAcessos(["*"]);
          localStorage.setItem("acessos", JSON.stringify(["*"]));
        } else {

          const acessosAssinante =
            user.assinante_membership?.plano?.acessos ?? [];

          const acessosEmpresa =
            user.empresa_membership?.plano?.acessos ?? [];

          const acessosNormalizados = Array.from(
            new Set([...acessosAssinante, ...acessosEmpresa])
          );

          setAcessos(acessosNormalizados);
          localStorage.setItem(
            "acessos",
            JSON.stringify(acessosNormalizados)
          );
        }

        localStorage.setItem("user", JSON.stringify(user));
      })
      .catch(() => {
        authService.logout();
        localStorage.clear();
        setAcessos([]);
        window.location.replace("/login");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);



  if (loading) {
    return <Loading />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/dashboarddetails" element={<DashboardDetails />} />
        <Route path="/socioeconomico"
          element={
            <ProtectedRoute
              element={<Socioeconomico />}
              permission="SOCIOECONOMICO"
              acessos={acessos}
            />
          }
        />
        <Route path="/empreendimentos"
          element={
            <ProtectedRoute
              element={<Empreendimentos />}
              permission="LISTA_EMPREENDIMENTO"
              acessos={acessos}
            />
          }
        />
        <Route path="/empreendimentos/:id" element={<DetalhesEmpreendimento />} />
        <Route path="/mapa"
          element={
            <ProtectedRoute
              element={<Mapa />}
              permission="MAPA_INTERATIVO"
              acessos={acessos}
            />
          }
        />
        <Route path="/planos" element={<Planos />} />
        <Route path="/configuracoes" element={<Configuracoes />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/esqueciSenha" element={<EsqueciSenha />} />
        <Route path="/login/mudarSenha" element={<MudarSenha />} />
        <Route path="/cadastro/:token" element={<Cadastro />} />
        <Route path="/sem-acesso" element={<SemAcesso />} />
      </Routes>
    </Router>
  );
}

export default App;
